import { Props, Status } from './interfaces'
import * as Styled from './styled'
import { ChangeEvent, useState, useMemo, useCallback } from 'react'
import { InputValid, InputInvalid } from '~components'
import DefaultInput from '../../dumbs/Input'
import MaskedInput from '../../dumbs/MaskedInput'

function Field({
  whenShowValidation,
  name,
  label,
  error,
  isValid,
  showSuccess,
  icon,
  message,
  className,
  ...inputProps
}: Props) {
  const [isValidationVisible, setValidationVisible] = useState(true)
  let status: Status

  if (isValidationVisible) {
    if (error) {
      status = 'danger'
    } else if (showSuccess && isValid) {
      status = 'success'
    }
  }

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (whenShowValidation) {
        setValidationVisible(whenShowValidation(event.target.value))
      }
    },
    [whenShowValidation],
  )

  const Input = inputProps.mask ? MaskedInput : DefaultInput

  return (
    <>
      {useMemo(
        () => (
          <Styled.Label htmlFor={name} $status={status}>
            {label}
          </Styled.Label>
        ),
        [name, label, status],
      )}
      {useMemo(
        () => (
          <Styled.Wrapper $status={status} className={className}>
            <Input {...inputProps} name={name} onChange={handleChange} />
            {status === 'danger' && <InputInvalid aria-label="input-invalid" />}
            {status === 'success' && <InputValid aria-label="input-valid" />}
            {!status && icon && icon}
          </Styled.Wrapper>
        ),
        [className, icon, status, name, inputProps, Input, handleChange],
      )}
      {useMemo(
        () =>
          status === 'danger' && error.message ? (
            <Styled.Error as="p">{error.message}</Styled.Error>
          ) : (
            message && <Styled.Message>{message}</Styled.Message>
          ),
        [message, error, status],
      )}
    </>
  )
}

Field.defaultProps = {
  showSuccess: false,
}

export default Field
